// tslint:disable:variable-name

export type StringFn = (str: string) => string;

export namespace Texts {

  export class Actions {
    public static readonly Failure: string = `Something went wrong`;
  }

  export class Problems {
    public static readonly AccountNotFound: string = `Account is invalid or not yet approved`;
  }
}
